import { render, staticRenderFns } from "./Factsheets.vue?vue&type=template&id=8665185e&scoped=true"
import script from "./Factsheets.vue?vue&type=script&lang=js"
export * from "./Factsheets.vue?vue&type=script&lang=js"
import style1 from "./Factsheets.vue?vue&type=style&index=1&id=8665185e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8665185e",
  null
  
)

export default component.exports